import type { LinkProps } from '@mui/material'
import { Link } from '@mui/material'
import React from 'react'
import type { LinkProps as ReactRouterLinkProps } from 'react-router-dom'
import { Link as ReactRouterLink } from 'react-router-dom'

export type RouterLinkProps = LinkProps & ReactRouterLinkProps

const RouterLink = ({ to, ...props }: RouterLinkProps): JSX.Element => (
  <Link component={ReactRouterLink} to={to} underline="hover" {...props}>
    {props.children}
  </Link>
)

export default RouterLink
